import { api } from '../../api/api';
import {
  PAYMENT_REQUEST, GET_PAYMENT_DASHBOARD_SUCCESS, GET_PAYMENTS_SUCCESS,
  ADD_PAYMENT_SUCCESS, UPDATE_PAYMENT_SUCCESS, DELETE_PAYMENT_SUCCESS,
  GET_PAYMENT_SUMMARY_SUCCESS, MARK_OVERDUE_SUCCESS,
} from '../constant';

export const getPaymentDashboard = (userId) => async (dispatch) => {
  if (userId == null || userId === '') return;
  dispatch({ type: PAYMENT_REQUEST });
  try {
    const res = await api.get(`/payment/dashboard/${userId}`);
    dispatch({ type: GET_PAYMENT_DASHBOARD_SUCCESS, payload: res.data });
  } catch (e) {}
};

export const getPayments = (userId, opts = {}) => async (dispatch) => {
  if (userId == null || userId === '') return;
  dispatch({ type: PAYMENT_REQUEST });
  try {
    const params = new URLSearchParams();
    if (opts.storeIds?.length) params.set('storeIds', opts.storeIds.join(','));
    const q = params.toString();
    // admin 이 아닌 경우(점주 My Store 등)는 자기 매장 결제만 읽는 API — /payment/list 는 admin 전용 (S0)
    const url = opts.mine
      ? `/payment/my?${q}`
      : (q ? `/payment/list/${userId}?${q}` : `/payment/list/${userId}`);
    const res = await api.get(url);
    dispatch({ type: GET_PAYMENTS_SUCCESS, payload: res.data.payments });
  } catch (e) {}
};

export const addPayment = (data) => async (dispatch) => {
  try {
    const res = await api.post('/payment/add', data);
    if (res.status === 201) dispatch({ type: ADD_PAYMENT_SUCCESS, payload: res.data.payment });
  } catch (e) {}
};

export const updatePayment = (id, data) => async (dispatch) => {
  const res = await api.patch(`/payment/update/${id}`, data);
  if (res.status === 200) dispatch({ type: UPDATE_PAYMENT_SUCCESS, payload: res.data.payment });
  return res.data.payment;
};

export const deletePayment = (id, opts = {}) => async (dispatch) => {
  await api.delete(`/payment/delete/${id}`, { data: opts });
  dispatch({ type: DELETE_PAYMENT_SUCCESS, payload: id });
};

export const generateMonthlyInvoices = (userId) => async (dispatch) => {
  try {
    const res = await api.post(`/payment/generate-invoices/${userId}`);
    if (res.data.created?.length > 0) {
      res.data.created.forEach(p => dispatch({ type: ADD_PAYMENT_SUCCESS, payload: p }));
    }
    return res.data;
  } catch (e) {}
};

export const getPaymentSummary = (userId) => async (dispatch) => {
  try {
    const res = await api.get(`/payment/summary/${userId}`);
    dispatch({ type: GET_PAYMENT_SUMMARY_SUCCESS, payload: res.data });
  } catch (e) {}
};

export const markOverdueInvoices = () => async (dispatch) => {
  try {
    const res = await api.post('/payment/mark-overdue');
    dispatch({ type: MARK_OVERDUE_SUCCESS, payload: res.data });
    return res.data;
  } catch (e) {}
};

export const syncInvoiceToQbo = (paymentId) => async () => {
  try {
    const res = await api.post('/qbo/invoices/sync', { paymentId });
    return res.data;
  } catch (e) { return { error: e.message }; }
};

export const syncPaymentStatusFromQbo = () => async () => {
  try {
    const res = await api.post('/qbo/invoices/sync-status');
    return res.data;
  } catch (e) { return { error: e.message }; }
};
